import cn from 'classnames';

export default function ContentColumn({
  children,
  columnSize = 'col-12 col-md-6 col-lg-5',
  ...rest
}) {
  return (
    <div
      className={cn(
        `${columnSize}`
      )}
      {...rest}
    >
      <div className="lds-half-billboard-content">
        {children}
      </div>
    </div>
  );
}
